import {AdsElementType} from '@jobseeker/common-core/types';
import {First, Second, Third, WinnerBg2} from '@jobseeker/lotus/assets/icons';
import {Avatar} from '@jobseeker/lotus/components';
import {Box, Grid, Typography, useTheme} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';

type WinnersAvatarType = {
  winnerData: AdsElementType & {rank: number};
};

const WinnersAvatar = (props: WinnersAvatarType) => {
  const {
    winnerData: {title, description, subText = '', rank, imageUrl},
  } = props;

  const theme = useTheme();

  if (rank <= 3) {
    return (
      <Grid container direction="column" alignItems="center">
        <Image
          src={rank === 1 ? First : rank === 2 ? Second : Third}
          width={213}
          height={73}
          alt={rank === 1 ? 'first' : rank === 2 ? 'second' : 'third'}
          style={{
            position: 'relative',
            zIndex: 1,
            top: 40,
          }}
        />
        <Avatar
          imgUrl={imageUrl}
          sx={{
            width: rank === 1 ? 328 : 245.6,
            height: rank === 1 ? 328 : 245.6,
            border: `${rank === 1 ? 18 : 15}px solid rebeccapurple`,
            color: theme.palette.primary.light,
            '&>img': {
              objectFit: 'contain',
            },
          }}
        />
        <Box
          sx={{
            width: 307,
            height: rank === 1 ? 116 : 114,
            backgroundImage: `url("${WinnerBg2?.src}")`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            pt: 0.75,
            color: theme.palette.primary.contrastText,
            position: 'relative',
            top: rank === 1 ? -100 : -60,
          }}
        >
          <Typography fontWeight={600} fontSize={theme.typography.pxToRem(18)}>
            {title}
          </Typography>
          <Typography
            fontWeight="normal"
            fontSize={theme.typography.pxToRem(16)}
          >
            {description}
          </Typography>
          <Typography
            mt={1.5}
            fontWeight="bold"
            fontSize={theme.typography.pxToRem(20)}
          >
            {subText}
          </Typography>
        </Box>
      </Grid>
    );
  }

  return (
    <>
      <Avatar
        imgUrl={imageUrl}
        sx={{
          width: 250,
          height: 250,
          border: '10px solid #e8e8e8',
          color: theme.palette.primary.light,
          mb: 1.5,
          '&>img': {
            objectFit: 'contain',
          },
        }}
      />
      <Typography fontWeight={600} fontSize={theme.typography.pxToRem(18)}>
        {title}
      </Typography>
      <Typography fontWeight="normal" fontSize={theme.typography.pxToRem(16)}>
        {description}
      </Typography>
    </>
  );
};

export default WinnersAvatar;
